export class BoardNotFoundError extends Error { }
